import { CopyIcon2, CustomDownloadIcon, CustomTimerIcon } from "@/assets";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";
import {
  formattedDate,
  formattedDateWithIntl,
  formattedTime,
  formattedTransactionDate,
} from "@/lib/helper";
import { useCopy } from "@/lib/useCopyToClipBoard";
import { useCurrency } from "@/lib/useCurrency";
import { cn } from "@/lib/utils";
import { getTransaction } from "@/services/Transactions.service";
import { useQuery } from "@tanstack/react-query";
import { toPng } from "html-to-image";
import { ChevronDown, ChevronLeft, Copy, TimerIcon } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { HiOutlineSlash } from "react-icons/hi2";
import { Link, useLocation, useParams } from "react-router";
import TransactionActions from "../transactions/common/TransactionActions";
import { ToastMessage, type } from "@/lib/toastr";
const Transaction = () => {
  const location = useLocation()?.pathname;
  let { id, transactionId } = useParams();
  const { copyToClipboard } = useCopy();
  const { handleSelectCurrency } = useCurrency();
  const transaction = useQuery({
    queryKey: ["transactionDetails", transactionId],
    queryFn: () => getTransaction(transactionId),
  });
  const [visible, setVisible] = useState(false);

  const elementRef = useRef<HTMLDivElement>(null);
  const downloadReceipt = () => {
    if (!elementRef.current) return;
    toPng(elementRef.current, { cacheBust: false,  })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "receipt.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err)
        ToastMessage(type.ERROR, "An error occurred while downloading receipt");
      });
  };

  useEffect(() => {
    if (visible) {
      downloadReceipt();
      setTimeout(() => setVisible(false), 1000);
    }
  }, [visible]);


  const dummdyData = {
  "businessBalanceActivities": [
      {
        "id": "3d775bea-d42a-46d0-9bf5-7c2da874e0b7",
        "type": "debit",
        "affectedBalance": "pending",
        "currencyCode": "USDT",
        "amount": 10,
        "balanceBefore": 10,
        "balanceAfter": 0,
        "createdAt": "2025-09-16T14:52:44.407Z",
        "updatedAt": "2025-09-16T14:52:44.407Z"
      },
      {
        "id": "5f899608-9b1d-401e-a246-a2fa4e61fd5b",
        "type": "credit",
        "affectedBalance": "pending",
        "currencyCode": "NGN",
        "amount": 14808.1,
        "balanceBefore": 0,
        "balanceAfter": 14808.1,
        "createdAt": "2025-09-16T14:52:44.414Z",
        "updatedAt": "2025-09-16T14:52:44.414Z"
      },
      {
        "id": "97e8f1bf-d148-4f7f-b32f-6b82cbc36c38",
        "type": "debit",
        "affectedBalance": "main",
        "currencyCode": "NGN",
        "amount": 14808.1,
        "balanceBefore": 1000000,
        "balanceAfter": 985191.9,
        "createdAt": "2025-09-16T14:52:44.416Z",
        "updatedAt": "2025-09-16T14:52:44.416Z"
      },
      {
        "id": "f29c6fdb-922a-4ec4-a74d-30406143377b",
        "type": "credit",
        "affectedBalance": "pending",
        "currencyCode": "USDT",
        "amount": 10,
        "balanceBefore": 0,
        "balanceAfter": 10,
        "createdAt": "2025-09-16T14:52:43.560Z",
        "updatedAt": "2025-09-16T14:52:43.560Z"
      },
      {
        "id": "ff8efc0a-144b-44e7-bc9e-41d1d3df981d",
        "type": "credit",
        "affectedBalance": "main",
        "currencyCode": "USDT",
        "amount": 10,
        "balanceBefore": 0,
        "balanceAfter": 10,
        "createdAt": "2025-09-16T14:52:44.409Z",
        "updatedAt": "2025-09-16T14:52:44.409Z"
      }
    ],
    "customerBalanceActivities": [
      {
        "id": "0e536b9b-a7b5-4ed4-a536-37e69e3f681e",
        "type": "credit",
        "affectedBalance": "pending",
        "currencyCode": "USDT",
        "amount": 10,
        "balanceBefore": 0,
        "balanceAfter": 10,
        "createdAt": "2025-09-16T14:52:43.551Z",
        "updatedAt": "2025-09-16T14:52:43.551Z"
      },
      {
        "id": "6ff27f40-8a63-4815-a797-8648131809a6",
        "type": "credit",
        "affectedBalance": "pending",
        "currencyCode": "NGN",
        "amount": 14808.1,
        "balanceBefore": 0,
        "balanceAfter": 14808.1,
        "createdAt": "2025-09-16T14:52:44.418Z",
        "updatedAt": "2025-09-16T14:52:44.418Z"
      },
      {
        "id": "7f6922d7-e99b-406f-a993-fdd3e016b2dc",
        "type": "debit",
        "affectedBalance": "pending",
        "currencyCode": "USDT",
        "amount": 10,
        "balanceBefore": 10,
        "balanceAfter": 0,
        "createdAt": "2025-09-16T14:52:44.412Z",
        "updatedAt": "2025-09-16T14:52:44.412Z"
      }
  ]}
  const [showAllActivities, setShowAllActivities] = useState(false);
  const [showAllCustomerActivities, setShowAllCustomerActivities] = useState(false);

  // Helper functions for activity rendering
  const activityDisplayData = showAllActivities
    ? transaction?.data?.data?.data?.businessBalanceActivities
    :transaction?.data?.data?.data?.businessBalanceActivities?.slice(0, 3);

  const customerActivityDisplayData = showAllCustomerActivities
    ? transaction?.data?.data?.data?.customerBalanceActivities
    : transaction?.data?.data?.data?.customerBalanceActivities?.slice(0, 3);

    transaction?.data?.data?.data?.beneficiary
  const getActivityLabel = (item: {
    type: string;
    currencyCode: string;
  }) => {
    if (item?.type === "debit") {
      return `Debited ${item?.currencyCode} Balance`;
    }
    return `Credited ${item?.currencyCode} Balance`;
  };

  const formatAmount = (amount: number, currency: string) => `${amount?.toLocaleString()} ${currency}`;
  const formatBalance = (balance: number, currency: string) => `${balance?.toLocaleString()} ${currency}`;
  const formatAffectedBalance = (affected: string) => affected ? affected.charAt(0).toUpperCase() + affected.slice(1) : "";

  return (
    <div className="grid gap-10 px-6 py-3">
      <div className="flex flex-col gap-8">
        <div>
          <Breadcrumb>
            <BreadcrumbList className="gap-2">
              <BreadcrumbItem>
                <Link
                  to={`/dashboard/${location?.includes("users") ? "users" : "transactions"
                    }`}
                  className="flex items-center gap-1 text-sm text-primary0"
                >
                  <ChevronLeft className="w-3 h-3" />
                  {location?.includes("users") ? "Users" : "Transactions"}
                </Link>
              </BreadcrumbItem>
              {location?.includes("users") ? (
                <>
                  <BreadcrumbSeparator>
                    <HiOutlineSlash />
                  </BreadcrumbSeparator>
                  <BreadcrumbItem>
                    {transaction?.isFetching ? (
                      <Skeleton className="w-full h-4" />
                    ) : (
                      <Link
                        to={`/dashboard/customers/${id}`}
                        className="flex items-center gap-1 text-sm text-gray-60"
                      >
                        {transaction?.data?.data?.data?.customer?.firstName}{" "}
                        {transaction?.data?.data?.data?.customer?.lastName}
                      </Link>
                    )}
                  </BreadcrumbItem>
                  <BreadcrumbSeparator>
                    <HiOutlineSlash />
                  </BreadcrumbSeparator>
                  <BreadcrumbItem>
                    {transaction?.isFetching ? (
                      <Skeleton className="w-full h-4" />
                    ) : (
                      <BreadcrumbLink className="flex items-center gap-1 text-sm text-gray-60">
                        {transaction?.data?.data?.data?.id}
                      </BreadcrumbLink>
                    )}
                  </BreadcrumbItem>
                </>
              ) : (
                <>
                  <BreadcrumbSeparator>
                    <HiOutlineSlash />
                  </BreadcrumbSeparator>
                  <BreadcrumbItem>
                    {transaction?.isFetching ? (
                      <Skeleton className="w-full h-4" />
                    ) : (
                      <BreadcrumbLink className="flex items-center gap-1 text-sm text-gray-60">
                        {transaction?.data?.data?.data?.id}
                      </BreadcrumbLink>
                    )}
                  </BreadcrumbItem>
                </>
              )}
            </BreadcrumbList>
          </Breadcrumb>
        </div>
        <div className="flex justify-between">
          <div className="flex flex-col ">
            <h4 className="text-2xl text-primary">About this transaction</h4>
            <p className="text-sm text-gray-80">
              View this transaction details below
            </p>
          </div>

          <div className="flex gap-4">
            {transaction?.data?.data?.data === undefined ? (
              <Skeleton className="w-48 h-10" />
            ) : (
              <Button
                variant="outline"
                className="border-primary0 text-primary0 hover:text-primary0"
                onClick={() => {
                  setVisible(true);
                  
                }}
              >
                <CustomDownloadIcon />
                Download Receipt
              </Button>
            )}
            {/* <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  disabled={
                    transaction?.data?.data?.data?._status == "success" ||
                    transaction?.data?.data?.data?.status == "success" ||
                    transaction?.data?.data?.data?.status == "cancelled"
                  }
                >
                  Quick Action
                  <ChevronDown />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
              </DropdownMenuContent>
            </DropdownMenu> */}

            {transaction?.data?.data?.data === undefined ? (
              <Skeleton className="w-36 h-10" />
            ) : (
              <>
                {transaction?.data?.data?.data?._status === "success" ||
                  transaction?.data?.data?.data?.status === "success" ||
                  transaction?.data?.data?.data?.status === "cancelled" ? null : (
                  <TransactionActions
                    id={transaction?.data?.data?.data?.id}
                    customerId={transaction?.data?.data?.data?.customer?.id}
                    normalStatus={transaction?.data?.data?.data?.status}
                    status={transaction?.data?.data?.data?._status}
                  />
                )}
              </>
            )}
          </div>
        </div>
        <Separator />
        <div className="grid gap-5">
          <div className="flex flex-col w-full lg:w-[762px] bg-off-white-1 rounded-[12px] p-8 gap-8">
            <div className="flex items-center gap-2">
              {transaction?.data?.data?.data === undefined ? (
                <Skeleton className="w-[120px] h-4" />
              ) : (
                <p className="text-xl text-right lg:text-2xl text-primary flex gap-2 items-center">
                  {handleSelectCurrency(transaction?.data?.data?.data?.currency)
                    ?.type === "fiat" && (
                      <span>
                        {handleSelectCurrency(
                          transaction?.data?.data?.data?.currency
                        )?.type === "fiat" &&
                          transaction?.data?.data?.data?.type === "payout" &&
                          transaction?.data?.data?.data?.currency}

                        {handleSelectCurrency(
                          transaction?.data?.data?.data?.currency
                        )?.type === "fiat" &&
                          transaction?.data?.data?.data?.type === "payin" &&
                          transaction?.data?.data?.data?.currency}
                      </span>
                    )}

                  {transaction?.data?.data?.data?.type === "cross"
                    ? transaction?.data?.data?.data?.swapCurrenc === null ||
                      transaction?.data?.data?.data?.withdrawalCurrency === null
                      ? "N/A"
                      : `${transaction?.data?.data?.data?.swapCurrency ||
                      transaction?.data?.data?.data?.withdrawalCurrency
                      } ${transaction?.data?.data?.data?.swapAmount?.toLocaleString(
                        "en-US"
                      ) ||
                      transaction?.data?.data?.data?.withdrawalAmount?.toLocaleString(
                        "en-US"
                      )
                      }`
                    : `${transaction?.data?.data?.data?.amount?.toLocaleString(
                      "en-Us"
                    )}`}

                  {handleSelectCurrency(transaction?.data?.data?.data?.currency)
                    ?.type === "crypto" && (
                      <span>
                        {handleSelectCurrency(
                          transaction?.data?.data?.data?.currency
                        )?.type === "crypto" &&
                          transaction?.data?.data?.data?.type === "payout" &&
                          transaction?.data?.data?.data?.currency}

                        {handleSelectCurrency(
                          transaction?.data?.data?.data?.currency
                        )?.type === "crypto" &&
                          transaction?.data?.data?.data?.type === "payin" &&
                          transaction?.data?.data?.data?.currency}
                      </span>
                    )}
                </p>
              )}

              {transaction?.data?.data?.data === undefined ? (
                <Skeleton className="w-[100px] h-4" />
              ) : (
                <span
                  className={cn(
                    "inline-flex items-center justify-center w-fit text-base text-center px-2 py-1 rounded-[4px] capitalize font-medium font-graphik",
                    transaction?.data?.data?.data?._status ===
                      "pending_withdrawal" ||
                      transaction?.data?.data?.data?._status ===
                      "pending_swap" ||
                      transaction?.data?.data?.data?._status ===
                      "pending_payin" ||
                      transaction?.data?.data?.data?._status === "pending" ||
                      transaction?.data?.data?.data?._status === "processing"
                      ? "bg-saffron-10 text-saffron"
                      : transaction?.data?.data?.data?._status === "blocked" ||
                        transaction?.data?.data?.data?._status ===
                        "cancelled" ||
                        transaction?.data?.data?.data?._status === "failed"
                        ? "bg-error-0 text-error-2"
                        : transaction?.data?.data?.data?._status === "queued"
                          ? "bg-blue-400 text-blue-700"
                          : "bg-green-0 text-green-3"
                  )}
                >
                  {transaction?.data?.data?.data?._status}
                </span>
              )}
            </div>
            <Separator />
            <div className="flex flex-col gap-6">
              <h4 className="text-primary text-base font-bold">
                Transaction Info
              </h4>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  Consumer Status
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <span
                      className={cn(
                        "inline-flex items-center justify-center w-fit text-base text-center px-2 py-1 rounded-[4px] capitalize font-medium font-graphik",
                        transaction?.data?.data?.data?.status === "pending"
                          ? "bg-saffron-10 text-saffron"
                          : transaction?.data?.data?.data?.status ===
                            "failed" ||
                            transaction?.data?.data?.data?._status ===
                            "cancelled"
                            ? "bg-error-0 text-error-2"
                            : "bg-green-0 text-green-3"
                      )}
                    >
                      {transaction?.data?.data?.data?.status}
                    </span>
                  </div>
                )}
              </div>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  Date & Time
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                      {formattedDate(transaction?.data?.data?.data?.createdAt)}{" "}
                      <span className="text-gray-70 ml-3">
                        {formattedTime(
                          transaction?.data?.data?.data?.createdAt
                        )}
                      </span>
                    </p>
                  </div>
                )}
              </div>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">Currency</p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <p className="text-xs capitalize lg:text-base text-[#1B1D22] flex gap-2 items-center">
                      <img
                        src={
                          handleSelectCurrency(
                            transaction?.data?.data?.data?.currency
                          )?.icon
                        }
                      />

                      {
                        handleSelectCurrency(
                          transaction?.data?.data?.data?.currency
                        )?.code
                      }
                    </p>
                  </div>
                )}
              </div>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  Amount Received
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <p className="text-xs capitalize lg:text-base text-[#1B1D22] ">
                      {handleSelectCurrency(
                        transaction?.data?.data?.data?.currency
                      )?.type === "fiat"
                        ? transaction?.data?.data?.data?.type === "payin" &&
                        `${transaction?.data?.data?.data?.currency
                        } ${transaction?.data?.data?.data?.amount?.toLocaleString(
                          "en-Us"
                        )}`
                        : transaction?.data?.data?.data?.type === "payin" &&
                        `
                          ${transaction?.data?.data?.data?.amount?.toLocaleString(
                          "en-Us"
                        )}
                          ${transaction?.data?.data?.data?.currency} 
                          
                          `}
                      {transaction?.data?.data?.data?.type === "payout" && 'N/A'}
                      {transaction?.data?.data?.data?.type === "cross" &&
                        `${transaction?.data?.data?.data?.amount?.toLocaleString(
                          "en-US"
                        )} ${transaction?.data?.data?.data?.currency?.toUpperCase()} 
                          `}
                    </p>
                  </div>
                )}
              </div>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  Exchange Rate
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <p className="text-xs capitalize lg:text-base text-[#1B1D22] ">
                      {transaction?.data?.data?.data?.withdrawalCurrency !==
                        null
                        ? `1 ${transaction?.data?.data?.data?.currency} / ${handleSelectCurrency(
                          transaction?.data?.data?.data?.withdrawalCurrency
                        )?.symbol
                        } ${transaction?.data?.data?.data?.rate}`
                        : "-"}
                    </p>
                  </div>
                )}
              </div>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  Amount Paid Out
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <p className="text-xs capitalize lg:text-base text-[#1B1D22] ">
                      {transaction?.data?.data?.data?.type !== "cross" ? null :
                        (transaction?.data?.data?.data?.type === "cross" &&
                          transaction?.data?.data?.data?.swapCurrency === null ||
                          transaction?.data?.data?.data?.withdrawalCurrency === null)
                          ? "N/A"
                          : `${transaction?.data?.data?.data?.swapCurrency?.toUpperCase() ||
                          transaction?.data?.data?.data?.withdrawalCurrency?.toUpperCase()
                          } ${transaction?.data?.data?.data?.swapAmount?.toLocaleString(
                            "en-US"
                          ) ||
                          transaction?.data?.data?.data?.withdrawalAmount?.toLocaleString(
                            "en-US"
                          )
                          }
                      `}
                      {transaction?.data?.data?.data?.type === "payin" && 'N/A'}
                      {transaction?.data?.data?.data?.type === "payout" &&
                        handleSelectCurrency(
                          transaction?.data?.data?.data?.currency
                        )?.type === "fiat" &&
                        `${transaction?.data?.data?.data?.currency
                        } ${transaction?.data?.data?.data?.amount?.toLocaleString(
                          "en-Us"
                        )}`}

                      {transaction?.data?.data?.data?.type === "payout" &&
                        handleSelectCurrency(
                          transaction?.data?.data?.data?.currency
                        )?.type === "crypto" &&
                        `${transaction?.data?.data?.data?.amount?.toLocaleString(
                          "en-Us"
                        )} ${transaction?.data?.data?.data?.currency}`}
                    </p>
                  </div>
                )}
              </div>

              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  Reference No.
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                      {transaction?.data?.data?.data?.reference === null
                        ? "N/A"
                        : transaction?.data?.data?.data?.id?.slice(0, 15) +
                        "..."}
                      {transaction?.data?.data?.data?.reference !== null && (
                        <Button
                          className="p-2 text-primary h-0 ml-4 cursor-pointer"
                          variant="ghost"
                          onClick={() => {
                            ToastMessage(type.INFO, "Copied");
                            copyToClipboard(transaction?.data?.data?.data?.id);
                          }}
                        >
                          <CopyIcon2 />
                        </Button>
                      )}
                    </p>
                  </div>
                )}
              </div>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  Provider Reference
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                      {transaction?.data?.data?.data?.providerReference === null
                        ? "N/A"
                        : transaction?.data?.data?.data?.providerReference?.slice(
                          0,
                          15
                        ) + "..."}
                      {transaction?.data?.data?.data?.providerReference !==
                        null && (
                          <Button
                            className="p-2 text-primary h-0 ml-4 cursor-pointer"
                            variant="ghost"
                            onClick={() =>
                              copyToClipboard(
                                transaction?.data?.data?.data?.providerReference
                              )
                            }
                          >
                            <CopyIcon2 />
                          </Button>
                        )}
                    </p>
                  </div>
                )}
              </div>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  Withdrawal Provider Reference
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                      {transaction?.data?.data?.data
                        ?.withdrawalProviderReference === null
                        ? "N/A"
                        : transaction?.data?.data?.data?.withdrawalProviderReference?.slice(
                          0,
                          15
                        ) + "..."}
                      {transaction?.data?.data?.data
                        ?.withdrawalProviderReference !== null && (
                          <Button
                            className="p-2 text-primary h-0 ml-4 cursor-pointer"
                            variant="ghost"
                            onClick={() =>
                              copyToClipboard(
                                transaction?.data?.data?.data
                                  ?.withdrawalProviderReference
                              )
                            }
                          >
                            <CopyIcon2 />
                          </Button>
                        )}
                    </p>
                  </div>
                )}
              </div>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">Error info</p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                      {transaction?.data?.data?.data?.transactionError}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <Separator />
            <div className="flex flex-col gap-6">
              <h4 className="text-primary text-base font-bold">Customer Info</h4>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  {transaction?.data?.data?.data?.customer === null
                    ? "Business"
                    : "Customer"}{" "}
                  Name
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    {transaction?.data?.data?.data?.customer === null ? (
                      <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                        {transaction?.data?.data?.data?.business?.name}
                      </p>
                    ) : (
                      <Link
                        to={`/dashboard/customers/${transaction?.data?.data?.data?.customer?.id}`}
                        className="text-xs capitalize lg:text-base text-primary underline underline-offset-1"
                      >
                        {transaction?.data?.data?.data?.customer?.firstName}{" "}
                        {transaction?.data?.data?.data?.customer?.lastName}
                      </Link>
                    )}
                  </div>
                )}
              </div>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  {transaction?.data?.data?.data?.customer === null
                    ? "Business"
                    : "Customer"}{" "}
                  Email
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>
                    <div className="w-[250px]">
                      <p className="text-xs capitalize lg:text-base text-[#1B1D22] break-words text-wrap">
                        {transaction?.data?.data?.data?.customer === null
                          ? transaction?.data?.data?.data?.business?.email
                          : transaction?.data?.data?.data?.customer?.email}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  {transaction?.data?.data?.data?.customer === null
                    ? "Business"
                    : "Customer"}{" "}
                  ID
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                      {transaction?.data?.data?.data?.customer === null
                        ? transaction?.data?.data?.data?.business?.id
                        : transaction?.data?.data?.data?.customer?.id?.slice(
                          0,
                          15
                        ) + "..."}

                      <Button
                        className="p-2 text-primary h-0 ml-4 cursor-pointer"
                        variant="ghost"
                        onClick={() =>
                          copyToClipboard(
                            transaction?.data?.data?.data?.customer === null
                              ? transaction?.data?.data?.data?.business?.id
                              : transaction?.data?.data?.data?.customer?.id
                          )
                        }
                      >
                        <CopyIcon2 />
                      </Button>
                    </p>
                  </div>
                )}
              </div>
            </div>
            {transaction?.data?.data?.data?.beneficiary === null ? null : (
              <>
                <Separator />
                <div className="flex flex-col gap-6">
                  <h4 className="text-primary text-base font-bold">
                    Beneficiary Details
                  </h4>
                  <div className="flex gap-8 items-center justify-between">
                    <p className="text-xs lg:text-base text-gray-60 ">
                      {transaction?.data?.data?.data?.beneficiary?.type ===
                        "bank" ||
                        transaction?.data?.data?.data?.type === "cross" ||
                        transaction?.data?.data?.data?.beneficiary === null
                        ? "Bank name"
                        : "Network"}
                    </p>
                    {transaction?.data?.data?.data === undefined ? (
                      <Skeleton className="w-[304px] h-4" />
                    ) : (
                      <div className="flex gap-16 items-center w-[304px]">
                        <p className="text-xs lg:text-base text-gray-60">:</p>

                        <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                          {transaction?.data?.data?.data?.beneficiary?.type ===
                            "bank"
                            ? transaction?.data?.data?.data?.beneficiary
                              ?.details?.bankName
                            : transaction?.data?.data?.data?.beneficiary
                              ?.details?.network}
                          {transaction?.data?.data?.data?.beneficiary?.type ===
                            "bank" ? null : (
                            <Button
                              className="p-2 text-primary h-0 ml-4 cursor-pointer"
                              variant="ghost"
                              onClick={() =>
                                copyToClipboard(
                                  transaction?.data?.data?.data?.beneficiary
                                    ?.type === "bank"
                                    ? transaction?.data?.data?.data?.beneficiary
                                      ?.details?.bankName
                                    : transaction?.data?.data?.data?.beneficiary
                                      ?.details?.network
                                )
                              }
                            >
                              <CopyIcon2 />
                            </Button>
                          )}
                        </p>
                      </div>
                    )}
                  </div>
                  {transaction?.data?.data?.data?.beneficiary?.type ===
                    "bank" ||
                    transaction?.data?.data?.data?.type === "cross" ||
                    transaction?.data?.data?.data?.beneficiary === null ? (
                    <div className="flex gap-8 items-center justify-between">
                      <p className="text-xs lg:text-base text-gray-60 ">
                        Account No.
                      </p>
                      {transaction?.data?.data?.data === undefined ? (
                        <Skeleton className="w-[304px] h-4" />
                      ) : (
                        <div className="flex gap-16 items-center w-[304px]">
                          <p className="text-xs lg:text-base text-gray-60">:</p>

                          <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                            {
                              transaction?.data?.data?.data?.beneficiary
                                ?.details?.accountNumber
                            }

                            <Button
                              className="p-2 text-primary h-0 ml-4 cursor-pointer"
                              variant="ghost"
                              onClick={() =>
                                copyToClipboard(
                                  transaction?.data?.data?.data?.beneficiary
                                    ?.details?.accountNumber
                                )
                              }
                            >
                              <CopyIcon2 />
                            </Button>
                          </p>
                        </div>
                      )}
                    </div>
                  ) : null}
                  <div className="flex gap-8 items-center justify-between">
                    <p className="text-xs lg:text-base text-gray-60 ">
                      {transaction?.data?.data?.data?.beneficiary?.type ===
                        "bank"
                        ? "Account Name"
                        : "Wallet Address"}
                    </p>
                    {transaction?.data?.data?.data === undefined ? (
                      <Skeleton className="w-[304px] h-4" />
                    ) : (
                      <div className="flex gap-16 items-center w-[304px]">
                        <p className="text-xs lg:text-base text-gray-60">:</p>

                        <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                          {transaction?.data?.data?.data?.beneficiary?.type ===
                            "bank"
                            ? transaction?.data?.data?.data?.beneficiary
                              ?.details?.accountName
                            : transaction?.data?.data?.data?.beneficiary
                              ?.details?.address}

                          <Button
                            className="p-2 text-primary h-0 ml-4 cursor-pointer"
                            variant="ghost"
                            onClick={() =>
                              copyToClipboard(
                                transaction?.data?.data?.data?.beneficiary
                                  ?.type === "bank"
                                  ? transaction?.data?.data?.data?.beneficiary
                                    ?.details?.accountName
                                  : transaction?.data?.data?.data?.beneficiary
                                    ?.details?.address
                              )
                            }
                          >
                            <CopyIcon2 />
                          </Button>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {transaction?.data?.data?.data?.businessBalanceActivities === null ||
            transaction?.data?.data?.data?.businessBalanceActivities?.length === 0
            ? null : (
            // {transaction?.data?.data?.data?.beneficiary === null ? null : (
              <>
                <Separator />
                <div className="flex flex-col gap-6">
                  <h4 className="text-primary text-base font-graphik font-bold mb-2">Merchant Balance Activity</h4>
                    <div className="flex flex-col gap-1 w-full">
                      {activityDisplayData?.map((item:any,index:number) => (
                        <div key={item.id} className="flex flex-row items-start gap-6 justify-between">
                          {/* Date/Time on the left */}
                          <div className="flex  items-center gap-3 h-full">
                            <div className="flex flex-col items-center">
                              <CustomTimerIcon />
                              <Separator orientation="vertical" className={cn("flex-grow min-h-[100px] bg-red-500",
                                index === activityDisplayData.length -1 ? 'bg-transparent' : 'bg-[#D5D8DB]'
                              )} />
                          
                            </div>
                            <div className="h-full flex items-start -mt-[8px]">

                            <p className="text-base text-[#4D525D]">
                              {formattedTransactionDate(item.createdAt)}, {formattedTime(item.createdAt)}
                            </p>
                            </div>
                          </div>
                          {/* Details on the right */}
                          <div className="flex flex-col justify-end gap-1 min-w-[220px]">
                            <div className="text-sm font-semibold font-graphik text-black">
                              {getActivityLabel(item)}
                            </div>
                            <div className="text-sm text-[#989898]">
                              Amount: {formatAmount(item.amount, item.currencyCode)}<br />
                              Balance Before: {formatBalance(item.balanceBefore, item.currencyCode)}<br />
                              Balance After: {formatBalance(item.balanceAfter, item.currencyCode)}<br />
                              Affected Balance: {formatAffectedBalance(item.affectedBalance)}
                            </div>
                          </div>
                        </div>
                      ))}
                        <Button
                          variant="link"
                          className="text-[#770072] text-sm font-semibold font-graphik w-fit px-0 no-underline"
                          onClick={() => setShowAllActivities(!showAllActivities)}
                        >
                          Show {showAllActivities? 'Less': 'more activity'}
                        </Button>
                    </div>
                </div>
              </>
            )}
            {transaction?.data?.data?.data?.customerBalanceActivities === null ||
            transaction?.data?.data?.data?.customerBalanceActivities?.length === 0 ? null : (

                  <>
                <Separator />
                <div className="flex flex-col gap-6">
                  <h4 className="text-primary text-base font-graphik font-bold mb-2">Customer Balance Activity</h4>
                    <div className="flex flex-col gap-1 w-full">
                      {customerActivityDisplayData?.map((item:any,index:number) => (
                        <div key={item.id} className="flex flex-row items-start gap-6 justify-between">
                          {/* Date/Time on the left */}
                          <div className="flex  items-center gap-3 h-full">
                            <div className="flex flex-col items-center">
                              <CustomTimerIcon />
                              <Separator orientation="vertical" className={cn("flex-grow min-h-[100px] bg-red-500",
                                index === customerActivityDisplayData.length -1 ? 'bg-transparent' : 'bg-[#D5D8DB]'
                              )} />
                          
                            </div>
                            <div className="h-full flex items-start -mt-[8px]">

                            <p className="text-base text-[#4D525D]">
                              {formattedTransactionDate(item.createdAt)}, {formattedTime(item.createdAt)}
                            </p>
                            </div>
                          </div>
                          {/* Details on the right */}
                          <div className="flex flex-col justify-end gap-1 min-w-[220px]">
                            <div className="text-sm font-semibold font-graphik text-black">
                              {getActivityLabel(item)}
                            </div>
                            <div className="text-sm text-[#989898]">
                              Amount: {formatAmount(item.amount, item.currencyCode)}<br />
                              Balance Before: {formatBalance(item.balanceBefore, item.currencyCode)}<br />
                              Balance After: {formatBalance(item.balanceAfter, item.currencyCode)}<br />
                              Affected Balance: {formatAffectedBalance(item.affectedBalance)}
                            </div>
                          </div>
                        </div>
                      ))}
                

                      <Button
                          variant="link"
                          className="text-[#770072] text-sm font-semibold font-graphik w-fit px-0 no-underline"
                          onClick={() => setShowAllCustomerActivities(!showAllCustomerActivities)}
                        >
                          Show {showAllCustomerActivities? 'Less': 'more activity'}
                        </Button>
       
                    </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Receipt
        transaction={transaction}
        elementRef={elementRef}
        show={visible}
      />
    </div>
  );
};

export default Transaction;

const Receipt = ({ transaction, elementRef, show }:any) => {
  const { handleSelectCurrency } = useCurrency();

  return (
    <div
      className={cn(
        " w-full lg:w-[765px] bg-off-white-1 rounded-[12px] p-8 gap-8 ",
        show ? "grid" : "hidden"
      )}
      ref={elementRef}
    >
      <div className="flex items-center gap-2">
        {transaction?.data?.data?.data === undefined ? (
          <Skeleton className="w-[120px] h-4" />
        ) : (
          <p className="text-xl text-right lg:text-2xl text-primary flex gap-2 items-center">
            {handleSelectCurrency(transaction?.data?.data?.data?.currency)
              ?.type === "fiat" && (
                <span>
                  {handleSelectCurrency(transaction?.data?.data?.data?.currency)
                    ?.type === "fiat" &&
                    transaction?.data?.data?.data?.type === "payout" &&
                    transaction?.data?.data?.data?.currency}

                  {handleSelectCurrency(transaction?.data?.data?.data?.currency)
                    ?.type === "fiat" &&
                    transaction?.data?.data?.data?.type === "payin" &&
                    transaction?.data?.data?.data?.currency}
                </span>
              )}

            {transaction?.data?.data?.data?.type === "cross"
              ? `
                    ${transaction?.data?.data?.data?.swapCurrency ||
              transaction?.data?.data?.data?.withdrawalCurrency
              } ${transaction?.data?.data?.data?.swapAmount?.toLocaleString(
                "en-US"
              ) ||
              transaction?.data?.data?.data?.withdrawalAmount?.toLocaleString(
                "en-US"
              )
              }`
              : `${transaction?.data?.data?.data?.amount?.toLocaleString(
                "en-Us"
              )}`}

            {handleSelectCurrency(transaction?.data?.data?.data?.currency)
              ?.type === "crypto" && (
                <span>
                  {handleSelectCurrency(transaction?.data?.data?.data?.currency)
                    ?.type === "crypto" &&
                    transaction?.data?.data?.data?.type === "payout" &&
                    transaction?.data?.data?.data?.currency}

                  {handleSelectCurrency(transaction?.data?.data?.data?.currency)
                    ?.type === "crypto" &&
                    transaction?.data?.data?.data?.type === "payin" &&
                    transaction?.data?.data?.data?.currency}
                </span>
              )}
          </p>
        )}

        {transaction?.data?.data?.data === undefined ? (
          <Skeleton className="w-[100px] h-4" />
        ) : (
          <span
            className={cn(
              "inline-flex items-center justify-center w-fit text-base text-center px-2 py-1 rounded-[37px] capitalize",
              transaction?.data?.data?.data?._status === "pending_withdrawal" ||
                transaction?.data?.data?.data?._status === "pending_swap" ||
                transaction?.data?.data?.data?._status === "pending_payin"
                ? "bg-saffron-10 text-saffron"
                : transaction?.data?.data?.data?._status === "blocked" ||
                  transaction?.data?.data?.data?._status === "failed"
                  ? "bg-error-0 text-error-2"
                  : "bg-green-0 text-green-3"
            )}
          >
            {transaction?.data?.data?.data?._status}
          </span>
        )}
      </div>
      <Separator />
      <div className="flex flex-col gap-6">
        <h4 className="text-primary text-base font-bold">Transaction Info</h4>
        <div className="flex gap-8 items-center justify-between">
          <p className="text-xs lg:text-base text-gray-60 ">Consumer Status</p>
          {transaction?.data?.data?.data === undefined ? (
            <Skeleton className="w-[304px] h-4" />
          ) : (
            <div className="flex gap-16 items-center w-[304px]">
              <p className="text-xs lg:text-base text-gray-60">:</p>

              <span
                className={cn(
                  "inline-flex items-center justify-center w-fit text-base text-center px-2 py-1 rounded-[37px] capitalize",
                  transaction?.data?.data?.data?.status === "pending"
                    ? "bg-saffron-10 text-saffron"
                    : transaction?.data?.data?.data?.status === "failed"
                      ? "bg-error-0 text-error-2"
                      : "bg-green-0 text-green-3"
                )}
              >
                {transaction?.data?.data?.data?.status}
              </span>
            </div>
          )}
        </div>
        <div className="flex gap-8 items-center justify-between">
          <p className="text-xs lg:text-base text-gray-60 ">Date & Time</p>
          {transaction?.data?.data?.data === undefined ? (
            <Skeleton className="w-[304px] h-4" />
          ) : (
            <div className="flex gap-16 items-center w-[304px]">
              <p className="text-xs lg:text-base text-gray-60">:</p>

              <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                {formattedDate(transaction?.data?.data?.data?.createdAt)}{" "}
                <span className="text-gray-70 ml-3">
                  {formattedTime(transaction?.data?.data?.data?.createdAt)}
                </span>
              </p>
            </div>
          )}
        </div>
        <div className="flex gap-8 items-center justify-between">
          <p className="text-xs lg:text-base text-gray-60 ">Currency</p>
          {transaction?.data?.data?.data === undefined ? (
            <Skeleton className="w-[304px] h-4" />
          ) : (
            <div className="flex gap-16 items-center w-[304px]">
              <p className="text-xs lg:text-base text-gray-60">:</p>

              <p className="text-xs capitalize lg:text-base text-[#1B1D22] flex gap-2 items-center">
                {/* <img
                  src={
                    handleSelectCurrency(
                      transaction?.data?.data?.data?.currency
                    )?.icon
                  }
                /> */}

                {
                  handleSelectCurrency(transaction?.data?.data?.data?.currency)
                    ?.code
                }
              </p>
            </div>
          )}
        </div>
        <div className="flex gap-8 items-center justify-between">
          <p className="text-xs lg:text-base text-gray-60 ">Amount Received</p>
          {transaction?.data?.data?.data === undefined ? (
            <Skeleton className="w-[304px] h-4" />
          ) : (
            <div className="flex gap-16 items-center w-[304px]">
              <p className="text-xs lg:text-base text-gray-60">:</p>

              <p className="text-xs capitalize lg:text-base text-[#1B1D22] ">
                {handleSelectCurrency(transaction?.data?.data?.data?.currency)
                  ?.type === "fiat"
                  ? transaction?.data?.data?.data?.type === "payin" &&
                  `${transaction?.data?.data?.data?.currency
                  } ${transaction?.data?.data?.data?.amount?.toLocaleString(
                    "en-Us"
                  )}`
                  : transaction?.data?.data?.data?.type === "payin" &&
                  `
                          ${transaction?.data?.data?.data?.amount?.toLocaleString(
                    "en-Us"
                  )}
                          ${transaction?.data?.data?.data?.currency} 
                          
                          `}
                {transaction?.data?.data?.data?.type === "cross" &&
                  `${transaction?.data?.data?.data?.amount?.toLocaleString(
                    "en-US"
                  )} ${transaction?.data?.data?.data?.currency?.toUpperCase()} 
                          `}
              </p>
            </div>
          )}
        </div>
        <div className="flex gap-8 items-center justify-between">
          <p className="text-xs lg:text-base text-gray-60 ">Exchange Rate</p>
          {transaction?.data?.data?.data === undefined ? (
            <Skeleton className="w-[304px] h-4" />
          ) : (
            <div className="flex gap-16 items-center w-[304px]">
              <p className="text-xs lg:text-base text-gray-60">:</p>

              <p className="text-xs capitalize lg:text-base text-[#1B1D22] ">
                {transaction?.data?.data?.data?.withdrawalCurrency !== null
                  ? `1 ${transaction?.data?.data?.data?.currency} / ${handleSelectCurrency(
                    transaction?.data?.data?.data?.withdrawalCurrency
                  )?.symbol
                  } ${transaction?.data?.data?.data?.rate}`
                  : "-"}
              </p>
            </div>
          )}
        </div>
        <div className="flex gap-8 items-center justify-between">
          <p className="text-xs lg:text-base text-gray-60 ">Amount Paid Out</p>
          {transaction?.data?.data?.data === undefined ? (
            <Skeleton className="w-[304px] h-4" />
          ) : (
            <div className="flex gap-16 items-center w-[304px]">
              <p className="text-xs lg:text-base text-gray-60">:</p>

              <p className="text-xs capitalize lg:text-base text-[#1B1D22] ">
                {transaction?.data?.data?.data?.type === "cross" &&
                  `${transaction?.data?.data?.data?.swapCurrency?.toUpperCase() ||
                  transaction?.data?.data?.data?.withdrawalCurrency?.toUpperCase()
                  } ${transaction?.data?.data?.data?.swapAmount?.toLocaleString(
                    "en-US"
                  ) ||
                  transaction?.data?.data?.data?.withdrawalAmount?.toLocaleString(
                    "en-US"
                  )
                  }
                      `}
                {transaction?.data?.data?.data?.type === "payout" &&
                  handleSelectCurrency(transaction?.data?.data?.data?.currency)
                    ?.type === "fiat" &&
                  `${transaction?.data?.data?.data?.currency
                  } ${transaction?.data?.data?.data?.amount?.toLocaleString(
                    "en-Us"
                  )}`}

                {transaction?.data?.data?.data?.type === "payout" &&
                  handleSelectCurrency(transaction?.data?.data?.data?.currency)
                    ?.type === "crypto" &&
                  `${transaction?.data?.data?.data?.amount?.toLocaleString(
                    "en-Us"
                  )} ${transaction?.data?.data?.data?.currency}`}
              </p>
            </div>
          )}
        </div>

        <div className="flex gap-8 items-center justify-between">
          <p className="text-xs lg:text-base text-gray-60 ">Reference No.</p>
          {transaction?.data?.data?.data === undefined ? (
            <Skeleton className="w-[304px] h-4" />
          ) : (
            <div className="flex gap-16 items-center w-[304px]">
              <p className="text-xs lg:text-base text-gray-60">:</p>

              <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                {transaction?.data?.data?.data?.reference === null
                  ? "N/A"
                  : transaction?.data?.data?.data?.id}
              </p>
            </div>
          )}
        </div>
        <div className="flex gap-8 items-center justify-between">
          <p className="text-xs lg:text-base text-gray-60 ">
            Provider Reference
          </p>
          {transaction?.data?.data?.data === undefined ? (
            <Skeleton className="w-[304px] h-4" />
          ) : (
            <div className="flex gap-16 items-center w-[304px]">
              <p className="text-xs lg:text-base text-gray-60">:</p>

              <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                {transaction?.data?.data?.data?.providerReference === null
                  ? "N/A"
                  : transaction?.data?.data?.data?.providerReference}
              </p>
            </div>
          )}
        </div>
        <div className="flex gap-8 items-center justify-between">
          <p className="text-xs lg:text-base text-gray-60 ">
            Withdrawal Provider Reference
          </p>
          {transaction?.data?.data?.data === undefined ? (
            <Skeleton className="w-[304px] h-4" />
          ) : (
            <div className="flex gap-16 items-center w-[304px]">
              <p className="text-xs lg:text-base text-gray-60">:</p>

              <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                {transaction?.data?.data?.data?.withdrawalProviderReference ===
                  null
                  ? "N/A"
                  : transaction?.data?.data?.data?.withdrawalProviderReference}
              </p>
            </div>
          )}
        </div>
      </div>
      {transaction?.data?.data?.data?.beneficiary === null ? null : (
        <>
          <Separator />
          <div className="flex flex-col gap-6">
            <h4 className="text-primary text-base font-bold">
              Beneficiary Details
            </h4>
            <div className="flex gap-8 items-center justify-between">
              <p className="text-xs lg:text-base text-gray-60 ">
                {transaction?.data?.data?.data?.beneficiary?.type === "bank" ||
                  transaction?.data?.data?.data?.type === "cross" ||
                  transaction?.data?.data?.data?.beneficiary === null
                  ? "Bank name"
                  : "Network"}
              </p>
              {transaction?.data?.data?.data === undefined ? (
                <Skeleton className="w-[304px] h-4" />
              ) : (
                <div className="flex gap-16 items-center w-[304px]">
                  <p className="text-xs lg:text-base text-gray-60">:</p>

                  <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                    {transaction?.data?.data?.data?.beneficiary?.type === "bank"
                      ? transaction?.data?.data?.data?.beneficiary?.details
                        ?.bankName
                      : transaction?.data?.data?.data?.beneficiary?.details
                        ?.network}
                  </p>
                </div>
              )}
            </div>
            {transaction?.data?.data?.data?.beneficiary?.type === "bank" ||
              transaction?.data?.data?.data?.type === "cross" ||
              transaction?.data?.data?.data?.beneficiary === null ? (
              <div className="flex gap-8 items-center justify-between">
                <p className="text-xs lg:text-base text-gray-60 ">
                  Account No.
                </p>
                {transaction?.data?.data?.data === undefined ? (
                  <Skeleton className="w-[304px] h-4" />
                ) : (
                  <div className="flex gap-16 items-center w-[304px]">
                    <p className="text-xs lg:text-base text-gray-60">:</p>

                    <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                      {
                        transaction?.data?.data?.data?.beneficiary?.details
                          ?.accountNumber
                      }
                    </p>
                  </div>
                )}
              </div>
            ) : null}
            <div className="flex gap-8 items-center justify-between">
              <p className="text-xs lg:text-base text-gray-60 ">
                {transaction?.data?.data?.data?.beneficiary?.type === "bank"
                  ? "Account Name"
                  : "Wallet Address"}
              </p>
              {transaction?.data?.data?.data === undefined ? (
                <Skeleton className="w-[304px] h-4" />
              ) : (
                <div className="flex gap-16 items-center w-[304px]">
                  <p className="text-xs lg:text-base text-gray-60">:</p>

                  <p className="text-xs capitalize lg:text-base text-[#1B1D22]">
                    {transaction?.data?.data?.data?.beneficiary?.type === "bank"
                      ? transaction?.data?.data?.data?.beneficiary?.details
                        ?.accountName
                      : transaction?.data?.data?.data?.beneficiary?.details
                        ?.address}
                  </p>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
